import React, { useState, useEffect, useContext } from 'react'
import ReactDOM from 'react-dom/client'
import { IntlProvider } from 'react-intl'
import 'antd/dist/reset.css'

import { LanguageContext } from './i18n/LanguageContext'
import { getLocale, getLanguageFile, defaultLanguage } from './i18n/locales'
import { ThemeProvider, darkModePreferred } from './Theme/ThemeContext'
import { AuthContext, AuthProvider } from './Components/Auth/AuthContext'

import App from './App'

const rootElement = document.getElementById("root") as HTMLElement
const root = ReactDOM.createRoot(rootElement)

const locale = getLocale()
const preferredLanguage = localStorage.getItem('preferredLanguage')

const Index = () => {
  const [ language, setLanguage ] = useState(preferredLanguage || defaultLanguage)
  const languageFile = getLanguageFile(language)

  useEffect(() => {
    localStorage.setItem('preferredLanguage', language)
  }, [ language ])

  const { isAuthenticated, hasLoginError } = useContext(AuthContext)

  return (
    <ThemeProvider isDarkMode={darkModePreferred} setDarkMode={() => void 0}>
      <LanguageContext.Provider value={{ language, setLanguage }}>
        <IntlProvider locale={locale} messages={languageFile}>
          <AuthProvider
            isAuthenticated={isAuthenticated}
            hasLoginError={hasLoginError}
            login={() => void 0}
            logout={() => void 0}
          >
            <App />
          </AuthProvider>
        </IntlProvider>
      </LanguageContext.Provider>
    </ThemeProvider>
  )
}

root.render(<Index />)